import styled from 'styled-components'
import { brandDarkGrey, brandIvory, brandWhite } from '../../../../assets/consts/color'
import { secondaryFont } from '../../../../assets/consts/fonts'

export const ReviewsBody = styled.div`
  position: relative;

  display: flex;
  justify-content: center;
  padding: 40px 0;

  @media only screen and (min-width: 48em) {
    padding: 80px 0;
  }
`

export const LoadingState = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1;

  pointer-events: none;
  opacity: ${({ loading }) => (loading ? 0.8 : 0)};
  background-color: ${brandWhite};
`

export const ReviewsHeader = styled(ReviewsBody)`
  padding-top: 120px;
  padding-bottom: 40px;
  background-color: ${brandIvory};

  @media only screen and (min-width: 48em) {
    padding-top: 160px;
    padding-bottom: 80px;
  }
`

export const ContentWrapper = styled.div`
  width: 100%;
  padding: 0 24px;

  .margin-customized p {
    margin-block-start: 0;
    margin-bottom: 80px;
  }

  @media only screen and (min-width: 48em) {
    width: 820px;
  }
`

export const ReviewList = styled.ul`
  display: grid;
  gap: 40px;
  padding: 0;

  list-style-type: none;

  li {
    margin: 0;
  }

  @media only screen and (min-width: 48em) {
    gap: 80px;
  }
`

export const ControlsWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 8px;
`

export const SubWrapper = styled(ControlsWrapper)`
  @media only screen and (max-width: 480px) {
    width: 100%;

    .stock-label,
    .add-review-button {
      width: 100% !important;
    }
  }
  @media only screen and (min-width: 48em) {
    gap: 40px;
  }
`

export const ProductTitle = styled.div`
  font-family: ${secondaryFont};
  font-size: 26px;
  font-weight: 700;
  letter-spacing: 0;
  line-height: 1.2;
  margin-top: 0.83em;
  color: ${brandDarkGrey};

  @media only screen and (min-width: 48em) {
    font-size: 39px;
  }
`
